exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(http://fonts.googleapis.com/css?family=Roboto);", ""]);

// module
exports.push([module.id, "body{height:100%}.hero{background-color:#263238;height:50rem;padding:3rem}.hero *{color:#f5f5f5}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./client/app/common/hero/hero.styl
// module id = 18
// module chunks = 0